<template>
  <div class="grid-view" style="padding-top: 5px">
    <query-bill-payment
      ref="queryBillPayment"
      :is-append-query="isAppendQuery"
      identify="queryBillPayment"
      view-source="billPaymentList"
      :show-real-clearing-state="searchConditions.showRealClearingState"
      :state="searchConditions.state"
      :paid-off="searchConditions.paidOff"
      :fin-approve-state="searchConditions.finApproveState"
      :is-check-charge="searchConditions.isCheckCharge"
      :show-controlled-charge="searchConditions.showControlledCharge"
      :show-fba="false"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      :clearing-states="searchConditions.clearingStates"
      :show-wht="showWht"
      :is-default-bill-payment="true"
      config-module="508"
      grid-config-module="190801"
      @dataProviderChange="dataProviderChange"
      @rowDoubleClicked="rowDoubleClicked"
      @toSearchTemplate="toSearchTemplate"
    >
      <div slot="operations">
        <el-button no="1" type="primary" @click="toDetail(false, null)">{{ $t('Payment.viewDetails') }}</el-button>
        <el-button no="2" type="primary" @click="toCollectInvoice">{{ $t('Payment.collectInvoice') }}</el-button>
        <!-- <el-button no="3" type="primary" @click="toPrint">{{ $t('Payment.print') }}</el-button> -->
        <el-dropdown
          no="3"
          split-button
          type="primary"
          style="margin: 0 5px;"
          @click="toPrint($t('Payment.print'))"
          @command="toPrint"
        >
          {{ $t('Payment.print') }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="$t('Clearing.PrintByPaymentRequestNumber')">{{ $t('Clearing.PrintByPaymentRequestNumber') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button no="4" type="primary" @click="toCreatePayment">{{ $t('Payment.newPaymentRequest') }}</el-button>
        <el-button v-show="searchConditions.applicationStatus === 0" no="5" type="primary" @click="doCommit">{{ $t('Payment.submit') }}</el-button>
        <el-button
          v-show="(searchConditions.applicationStatus === 0 || searchConditions.applicationStatus === 4) && this.$checkPermission(['button_ACPayAuth_btnBillDelete'])"
          no="6"
          type="danger"
          @click="doDelete"
        >
          {{ $t('Payment.delete') }}
        </el-button>
        <el-button
          v-show="searchConditions.applicationStatus === 1 && this.hasBusinessVerify"
          no="7"
          type="primary"
          @click="businessApprovalCheck"
        >
          {{ $t('Payment.businessApproval') }}
        </el-button>
        <el-button
          v-show="(searchConditions.applicationStatus === 1 && this.isDepartmentPermit && !billPaymentSetting.openUiCustom) || (isUiDepartmentApproval && searchConditions.applicationStatus === 6)"
          no="8"
          type="primary"
          @click="departmentApprovalCheck"
        >
          {{ $t('Payment.departmentApproval') }}
        </el-button>
        <el-button
          v-show="searchConditions.applicationStatus === 2 && this.$checkPermission(['button_ACPayAuth_financeVerify'])"
          no="9"
          type="primary"
          @click="financialApprovalCheck"
        >
          {{ $t('Payment.financialApproval') }}
        </el-button>
        <el-button
          v-show="searchConditions.applicationStatus === 11 && isUiSupervisorApproval && this.$checkPermission(['button_ACPayAuth_supervisorVerify'])"
          no="11"
          type="primary"
          @click="supervisorAuditCheck"
        >
          {{ $t('CargoMsg.Cargo_SupervisorReview') }}
        </el-button>
        <el-button
          v-show="(searchConditions.applicationStatus === 1 && this.hasBackPrivilege) || ((searchConditions.applicationStatus === 2 || searchConditions.applicationStatus === 3 || searchConditions.applicationStatus === 6 || searchConditions.applicationStatus === 11) && this.hasFinanceVerify)"
          no="10"
          type="primary"
          @click="backCheck"
        >
          {{ $t('Payment.return') }}
        </el-button>
        <el-button
          v-show="(searchConditions.applicationStatus === 1 && this.$checkPermission(['button_ACPayAuth_financeVerify']) && !billPaymentSetting.openUiCustom)"
          no="11"
          type="primary"
          @click="financialAuditCheck"
        >
          {{ $t('Payment.financialAudit') }}
        </el-button>
        <el-button v-show="showChangeBillPaymentBtn" no="12" type="primary" @click="toBatchChangeTime">{{ $t('Payment.changePaymentRequest') }}</el-button>
      </div>
      <template v-slot:searchAreaHeader>
        <div class="app-main-inner-row  extension-conditions-form">
          <div class="filters">
            <el-form :inline="true" :label-width="isZh ? '60px' : '155px'" label-position="left">
              <div class="el-form-item-wrapper dense-radio-group">
                <el-form-item v-if="!billPaymentSetting.openUiCustom" :label="$t('Payment.applicationStatus')" class="dense-radio-group">
                  <el-radio-group v-model="searchConditions.applicationStatus" no="13" @change="applicationStatusChange">
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbWait'])" no="14" :label="0">{{ $t('Payment.notSubmitted') }}</el-radio>
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbApproval'])" no="15" :label="1">{{ $t('Payment.awaitBusinessApproval') }}</el-radio>
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbFinanceVerify'])" no="16" :label="2">{{ $t('Payment.awaitFinancialApproval') }}</el-radio>
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbConfirm'])" no="17" :label="3">{{ $t('Payment.approval') }}</el-radio>
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbUnverify'])" no="18" :label="4">{{ $t('Payment.unpaid') }}</el-radio>
                    <el-radio v-show="$checkPermission(['tab_ACPayAuth_fbAll'])" no="19" :label="5">{{ $t('Payment.all') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Billing.billingJob_billPaymentDate')">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label-width="0">
                        <el-date-picker
                          v-model="searchConditions.inputDateStart"
                          no="20"
                          type="date"
                          style="width:100%;"
                          :clearable="false"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                        /></el-form-item>
                    </el-col>
                    <el-col :span="1"><span style="font-size: 12px;">{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
                    <el-col :span="8">
                      <el-form-item label-width="0">
                        <el-date-picker
                          v-model="searchConditions.inputDateEnd"
                          no="22"
                          type="date"
                          style="width:100%;"
                          clearable
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" style="padding-left: 5px">
                      <el-form-item label-width="0">
                        <el-checkbox v-model="allowTwoYearOutside" no="23">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </template>
    </query-bill-payment>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      @selectedTemplate="updatePrintField"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="billPaymentList"
      location="location"
      @reloadData="reloadData"
    />
    <!-- 同意弹窗 -->
    <el-dialog
      :visible.sync="agreeDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
      height="400px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: left;font-size: 14px;padding-bottom: 20px;">{{ $t('Payment.Cargo_ApplicantPassTips') }}</span>
        <el-input v-model="agreeDialog.remark" type="textarea" :rows="6" :placeholder="$t('Payment.approveReason')" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button
          @click="() => {
            agreeDialog.visible = false
            agreeDialog.remark = ''}"
        >{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 退回弹窗 -->
    <el-dialog
      :visible.sync="returnDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
      height="400px"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <span style="text-align: left;font-size: 14px;padding-bottom: 20px;">{{ returnDialog.returnTips }}</span>
        <el-input v-model="returnDialog.remark" type="textarea" :rows="6" :placeholder="$t('Payment.returnReason')" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doBack">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button
          @click="() => {
            returnDialog.visible = false
            returnDialog.remark = ''
          }"
        >{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量修改支付弹窗 -->
    <el-dialog
      v-if="changePaymentDialog.visible"
      v-el-drag-dialog
      :visible.sync="changePaymentDialog.visible"
      :title="$t('CargoMsg.Cargo_ChangePayment')"
      width="450px"
      height="400px"
      class="changePaymentRequest"
      :close-on-click-modal="false"
    >
      <template>
        <div>
          <div class="dialog-body" style="padding-left: 10px; padding-top: 20px; padding-bottom: 26px">
            <div>
              <span class="name">{{ $t('CargoMsg.Cargo_PaymentTimeLimit') }}</span>
              <el-date-picker v-model="changePaymentDialog.deadLine" :clearable="false" :editable="false" type="date" />
            </div>
            <div style="margin-top: 7px; display: flex">
              <span class="name" style="width: 25px; margin-left:23px">{{ $t('CargoMsg.Cargo_Remarks') }}</span>
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="changePaymentDialog.remark"
                  type="textarea"
                  :rows="5"
                  style="width: 220px"
                />
                <span style="margin-top: 7px">{{ $t('CargoMsg.Cargo_BillPaymentRemarkTip') }}</span>
              </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer" style="justify-content: right">
            <el-button type="primary" size="small" @click="changePaymentConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
            <el-button size="small" @click="changePaymentDialog.visible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import makeInvoiceStepOneDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceStepOneDialog'
import queryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPayment'
import moment from 'moment'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import { updateBillPaymentState, batchDelBillPayment, uploadHasPrint } from '@/api/clearing/billPayment'
import { cache, cacheName } from '@/utils/cacheManager'
import { getUserInfo } from '@/utils/auth'
import lodash from 'lodash'
import billPaymentCreatorDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentCreatorDialog'
import { changePaymentList } from '@/api/clearing/billPayment'
import { validateRoleByUserIdAndRoleName } from '@/api/role'
import GlobalDialog from '@/utils/GlobalDialog'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getBranchBillPaymentRuleSetting, getBranchBillPaymentSetting } from '@/api/sysManage/uiCustom'
import UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'

export default {
  name: 'BillPaymentList',
  components: {
    CargoDialog,
    cargoTemplateSelectorDialog,
    billPaymentDialog,
    makeInvoiceStepOneDialog,
    queryBillPayment, // 付款申请查询列表
    makeInvoiceDialog, // 开票弹出框
    billPaymentCreatorDialog // 创建付款申请弹窗
  },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    showWht: { type: Boolean, default: false }, // 是否需要展示去Wht金额
    viewSource: { type: String, default: '' }, // 来源
    billPaymentSetting: { type: Object, default: () => {} },
    applicationStatus: { type: Number, default: 0 } // 申请状态，默认未提交
  },
  data() {
    return {
      openSapConfig: false,
      billPaymentApproveDialogShow: 0,
      paymentChangeBusiness: this.$checkPermission(['button_ACPayAuth_modifyPaymentBusiness']),
      paymentChangeFinance: this.$checkPermission(['button_ACPayAuth_modifyPaymentFinance']),
      loading: false,
      searchConditions: {
        applicationStatus: 0,
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: '',
        state: [0], // 付款申请状态(默认值是：未提交状态)
        clearingStates: [], // 核销状态
        paidOff: -1, // 是否销账
        finApproveState: [], // 最终审批状态
        showControlledCharge: false,
        isCheckCharge: true,
        showRealClearingState: true,
        unCommittedRowData: [], // 未提交状态的表格数据
        unCommittedSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 未提交状态的查询条件
        unVerifyRowData: [], // 未提交状态的表格数据
        unVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待业务审批状态的查询条件
        financeUnVerifyRowData: [], // 待财务审批状态u的表格数据
        financeUnVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待财务审批状态的查询条件
        departmentUnVerifyRowData: [], // 待主管审批状态u的表格数据
        departmentUnVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待主管审批状态的查询条件
        supervisorUnVerifyRowData: [], // 待主管审批状态u的表格数据
        supervisorUnVerifySearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 待主管审批状态的查询条件
        verifiedRowData: [], // 审批通过状态的表格数据
        verifiedSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 审批通过状态的查询条件
        unPaidOffRowData: [], // 未付清状态的表格数据
        unPaidOffSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        }, // 未付清状态的查询条件
        allRowData: [], // 所有状态的表格数据
        allSearchConditions: {
          total: 0,
          pageNum: 1,
          pageSize: 20,
          requires: ['voucherNoCreateDate', 'targetVoucherNo'],
          snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
          jobStates: [] // 业务状态
        } // 所有状态的查询条件
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      hasBusinessVerify: false, // 是否有业务审批权限
      isDepartmentPermit: false, // 部门审批
      hasBackPrivilege: false, // 是否有退回权限
      hasFinanceVerify: false, // 财务审核权限
      isDirectPayment: false,
      isPaymentApplyFinancialAudit: false, // 待业务审核页面可以直接财务审核
      allowTwoYearOutside: false,
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      billPaymentDialog: { // 付款申请弹窗【查看明细】
        visible: false,
        title: '',
        billPaymentUuid: '',
        dialogs: []
      },
      makeInvoiceDialog: { // 收票弹窗页
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 5 // 开票方式:5代表账单
      },
      billPaymentCreatorDialog: null,
      // 同意弹窗
      agreeDialog: {
        visible: false,
        billPayments: [],
        remark: '', // 同意说明
        agreeType: 0 // 1-业务审批 2-部门审批 3-财务审核 4-财务审批
      },
      // 退回弹窗
      returnDialog: {
        visible: false,
        remark: '', // 退回说明
        returnTips: ''
      },
      // 修改付款申请弹窗
      changePaymentDialog: {
        visible: false,
        deadLine: '',
        rowDataList: [],
        remark: ''
      },
      billPaymentRuleSetting: {},
      location: LOG_BILL_PAYMENT.code
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    currentOffice() {
      return this.$store.getters.currentOfficeId
    },
    // 是否勾选UI自定义待部门审批页签
    isUiDepartmentApproval() {
      if (this.billPaymentSetting) {
        return this.billPaymentSetting.openUiCustom && this.billPaymentSetting.departmentApproval
      }
      return false
    },
    // 是否勾选UI自定义待主管审批页签
    isUiSupervisorApproval() {
      if (this.billPaymentSetting) {
        return this.billPaymentSetting.openUiCustom && this.billPaymentSetting.supervisorApproval
      }
      return false
    },
    showChangeBillPaymentBtn() {
      return (this.paymentChangeBusiness && this.searchConditions.applicationStatus === 1) ||
                (this.paymentChangeFinance && this.searchConditions.applicationStatus === 2) ||
                (this.isUiDepartmentApproval && this.searchConditions.applicationStatus === 6) ||
                (this.isUiSupervisorApproval && this.searchConditions.applicationStatus === 11)
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Invoice.invoice_unlockBusinessDateQuery'), this.$t('Message.Prompt'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    applicationStatus(val) {
      this.searchConditions.applicationStatus = val
      this.applicationStatusChange()
    },
    currentOffice() {
      this.initConfig()
    }
  },
  async created() {
    await this.initConfig()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.billPaymentCreatorDialog) {
      this.billPaymentCreatorDialog.instance.destroySelf()
    }
    for (const dialog of this.billPaymentDialog.dialogs) {
      dialog.instance.destroySelf()
    }
  },
  methods: {
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
      this.billPaymentApproveDialogShow = Number(cache.config.get('billPaymentApproveDialogShow'))
      let shae = false // 上海空运出口, 类似于 Department permit
      let isDirectPayment = false
      const roleMap = await validateRoleByUserIdAndRoleName(['上海空运付款', '付款申请直达']).then(res => {
        return res.data
      })
      if (roleMap) {
        if (roleMap.hasOwnProperty('上海空运付款') && roleMap['上海空运付款']) {
          shae = true
        }
        if (roleMap.hasOwnProperty('付款申请直达') && roleMap['付款申请直达']) {
          shae = true
          isDirectPayment = true
        }
      }
      this.isDirectPayment = isDirectPayment
      const billPaymentDepartmentPermit = Number(cache.config.get('BillPaymentDepartmentPermit'))
      if (billPaymentDepartmentPermit >= 1 || shae) {
        this.isDepartmentPermit = true
      } else {
        this.isDepartmentPermit = false
      }
      const paymentApplyFinancialAudit = Number(cache.config.get('PaymentApplyFinancialAudit'))
      if (paymentApplyFinancialAudit >= 1) {
        this.isPaymentApplyFinancialAudit = true
      } else {
        this.isPaymentApplyFinancialAudit = false
      }
      this.hasBusinessVerify = this.$checkPermission(['button_ACPayAuth_business'])
      const pd = this.$checkPermission(['button_ACPayAuth_department'])
      const p = this.$checkPermission(['button_ACPayAuth_business']) || getUserInfo().admin
      if (this.isDepartmentPermit) {
        this.hasBackPrivilege = pd || p
      } else {
        this.hasBackPrivilege = p
      }
      this.hasFinanceVerify = this.$checkPermission(['button_ACPayAuth_financeVerify'])
      await this.loadBillPaymentRuleSetting()
    },
    async loadBillPaymentRuleSetting() {
      // 如果开启了UI定制，则加载规则设置
      if (this.billPaymentSetting.openUiCustom && this.billPaymentSetting.supervisorApproval) {
        this.billPaymentRuleSetting = await getBranchBillPaymentRuleSetting({
          pageType: UICustomConstants.BILLPAYMENT_NATIVE_SUPERVISOR_APPROVAL,
          branchId: this.$store.getters.currentOfficeId
        }).then(res => res.data)
      }
    },
    // 批量修改时间
    changePaymentConfirm() {
      // 判断时间参数是否为空
      if (!this.changePaymentDialog.deadLine) {
        this.$message({
          message: this.$t('CargoMsg.Cargo_NotEmptyChangePaymentTime'),
          type: 'warning'
        })
        return
      }
      // 下发时间参数
      // 获取需要批量修改任务单号
      const uuidList = this.changePaymentDialog.rowDataList.map(item => item.uuid)
      // 下发请求
      const param = { 'billPaymentKeys': uuidList, 'deadLine': this.changePaymentDialog.deadLine, 'remark': this.changePaymentDialog.remark }
      this.loading = getLoading()
      changePaymentList(param).then(res => {
        if (res.code === '0') {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message({
            type: 'success',
            message: this.$t('CargoMsg.Cargo_batchChangePaymentSuccess')
          })
        } else {
          this.$message({
            type: 'error',
            message: this.$t('CargoMsg.Cargo_batchChangePaymentFailed')
          })
        }
      }).catch(e => {
        this.$message({
          type: 'error',
          message: this.$t('CargoMsg.Cargo_batchChangePaymentFailed')
        })
      }).finally(() => {
        this.changePaymentDialog.visible = false
        this.loading.close()
      })
    },
    // 打开批量修改付款弹窗，初始化参数
    toBatchChangeTime() {
      this.changePaymentDialog.rowDataList = this.$refs.queryBillPayment.getSelections()
      if (this.changePaymentDialog.rowDataList == null || this.changePaymentDialog.rowDataList.length === 0) {
        this.$message({
          message: this.$t('CargoMsg.Cargo_PleaseSelectTheRecord'),
          type: 'warning'
        })
        return
      }
      // 打开弹窗
      // CARGO-39655 只有选中单条数据时，带入备注信息
      this.changePaymentDialog.remark = ''
      if (this.changePaymentDialog.rowDataList.length === 1) {
        this.changePaymentDialog.remark = this.changePaymentDialog.rowDataList[0].remark
      }
      this.changePaymentDialog.visible = true
      this.changePaymentDialog.deadLine = DateUtils.formatStandardDate(new Date())
    },

    // 是否可选择两年以外的时间点
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 申请状态变更事件
    applicationStatusChange() {
      const searchConditions = this.searchConditions
      const applicationStatus = searchConditions.applicationStatus
      searchConditions.paidOff = -1
      searchConditions.clearingStates = []
      searchConditions.state = []
      searchConditions.finApproveState = []
      if (applicationStatus === 0) {
        searchConditions.state = [0]
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.unCommittedRowData, searchConditions.unCommittedSearchConditions)
      } else if (applicationStatus === 1) {
        if (this.isUiDepartmentApproval) { // 如果勾选了UI自定义待部门审批页签，则待业务审批页签只查询已提交的数据
          searchConditions.state = [1]
        } else {
          searchConditions.state = [1, 6]
        }
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.unVerifyRowData, searchConditions.unVerifySearchConditions)
      } else if (applicationStatus === 2) {
        const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 2)
        searchConditions.state = [beforeState]
        console.log('searchConditions.state', searchConditions.state)
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.financeUnVerifyRowData, searchConditions.financeUnVerifySearchConditions)
      } else if (applicationStatus === 3) {
        // const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 3)
        // searchConditions.state = [beforeState]
        searchConditions.finApproveState = [1]
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.verifiedRowData, searchConditions.verifiedSearchConditions)
      } else if (applicationStatus === 4) {
        searchConditions.state = [0, 1, 2, 3, 4, 5, 6, 7, 8, 11]
        searchConditions.clearingStates = [0, 1]
        searchConditions.paidOff = 0
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.unPaidOffRowData, searchConditions.unPaidOffSearchConditions)
      } else if (applicationStatus === 6) { // 待部门审批
        const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 2)
        searchConditions.state = [beforeState]
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.departmentUnVerifyRowData, searchConditions.departmentUnVerifySearchConditions)
      } else if (applicationStatus === 11) { // 待主管审批
        const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 3)
        searchConditions.state = [beforeState]
        searchConditions.finApproveState = [0, 2]
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.supervisorUnVerifyRowData, searchConditions.supervisorUnVerifySearchConditions)
      } else {
        searchConditions.state = [0, 1, 2, 3, 4, 5, 6, 7, 8, 11]
        this.$refs.queryBillPayment.changeDataProvider(searchConditions.allRowData, searchConditions.allSearchConditions)
      }
    },
    // 查看详情
    toDetail(doubleClick = false, row = null) {
      let billPayment = null
      if (doubleClick) { // 双击查看
        billPayment = row
      } else {
        const chooseRows = this.$refs.queryBillPayment.getSelections()
        if (chooseRows && chooseRows.length > 0) {
          billPayment = chooseRows[0]
        }
      }
      if (!billPayment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      if (billPayment.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(billPayment.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      this.billPaymentDialog.billPaymentUuid = billPayment.uuid
      this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      const propsData = {
        visible: true,
        title: this.billPaymentDialog.title,
        billPaymentUuid: this.billPaymentDialog.billPaymentUuid,
        isDirectPayment: this.isDirectPayment,
        openSapConfig: this.openSapConfig,
        toExoSystemYGSH: String(cache.config.get('ToExoSystem')) === 'YGSH', // 阳光速航
        step: 'step2',
        mode: 'edit',
        showWht: this.showWht,
        viewSource: 'billPayment',
        location: this.location
      }
      if (this.billPaymentDialog.dialogs.length > 0) {
        for (const item of this.billPaymentDialog.dialogs) {
          item.instance.visible = false
        }
      }
      const dialog = new GlobalDialog(billPaymentDialog, { propsData })
      const { instance } = dialog
      console.log('instance', instance)
      instance.$on('cancel', () => { dialog.instance.visible = false })
      instance.$on('reloadData', this.reloadData)
      instance.$on('saveSuccess', this.saveBillPaymentSuccess)
      this.billPaymentDialog.dialogs.push(dialog)
    },
    // 收票按钮触发事件
    toCollectInvoice() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const queryOfficeId = this.$refs.queryBillPayment.queryOfficeId
      if (queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      let message = ''
      // 选中数据中是否存在可开票账单
      let isC = false
      for (const bp of chooseRows) {
        if (!bp.notInvoiceByCharge) {
          if (message) {
            message += ','
          }
          message = message + bp.billPaymentNo
        } else {
          isC = true
        }
      }
      if (message && isC) {
        this.$message.warning(this.$t('Clearing.IncludesReSelectPaymentNumber') + message)
        return
      } else if (message && !isC) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      this.makeInvoiceDialog.isAr = false
      this.makeInvoiceDialog.isHedge = false
      this.makeInvoiceDialog.isSkipInvoiceFrom = false
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      this.makeInvoiceDialog.keys = keys
      this.makeInvoiceDialog.step = 'step1'
      this.$refs.invoice.makeInvoice({ ...this.makeInvoiceDialog })
    },
    // 创建付款申请
    toCreatePayment() {
      if (!this.billPaymentCreatorDialog) {
        const propsData = { viewSource: 'billPayment', location: this.location }
        this.billPaymentCreatorDialog = new GlobalDialog(billPaymentCreatorDialog, { propsData })
        const { instance } = this.billPaymentCreatorDialog
        instance.createBillPayment({ step: 'step1', title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees') })
        instance.$on('reloadData', this.reloadData)
        instance.$on('cancel', this.cancelBillPaymentCreatorDialog)
      } else {
        this.billPaymentCreatorDialog.instance.visible = true
      }
    },
    // 打印按钮触发事件
    toPrint(command) {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0) {
          keys.push(billPayment.uuid)
        }
      }
      const params = {}
      const multiplePrint = chooseRows.length > 1 && command === this.$t('Clearing.PrintByPaymentRequestNumber') // 是否按照多个打印
      if (chooseRows.length === 1 || multiplePrint) {
        params.BILLPAYMENT_UUID = chooseRows[0].uuid
        params.BILL_PAYMENT_UUID = chooseRows[0].uuid
        params.printSource = DocumentConstants.BATCH_PRINT_FKSQ.code
        if (multiplePrint) {
          params.multiplePrint = true
          params.multipleBillPaymentUuid = keys
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILL_PAYMENT_UUID_LIST = keys
        params.printSource = DocumentConstants.BATCH_PRINT_FKSQ.code
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
        this.templateSelectorDialog.visible = true
      }
    },
    // 提交按钮触发事件
    doCommit() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
          keys.push({ uuid: billPayment.uuid, version: billPayment.version })
        }
      }
      if (keys.length > 0) {
        if (parseInt(cache.config.get('BPM_StartOldApproval')) === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NotSupportStartOldApprove'))
          return
        }
        const params = {
          billPayments: keys,
          state: this.isDirectPayment ? 2 : 1,
          operation: 'commit',
          approveHistoryPlatform: true
        }
        this.jointCommonParam(params)
        updateBillPaymentState(params).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
          this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        }).catch().finally()
      }
    },
    // 删除按钮触发事件
    doDelete() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATD'))
        return
      }
      const list = []
      for (const billPayment of chooseRows) {
        if (this.hasBusinessVerify && billPayment.state <= 2 && billPayment.realClearingState === 0) { list.push(billPayment) } else if (!this.hasBusinessVerify && billPayment.state <= 1 && billPayment.realClearingState === 0) { list.push(billPayment) }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('Message.BillPaymentDeleteTips'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_STDTPA'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const mapBillPayment = []
        for (const billPayment of list) {
          if (billPayment.uuid && billPayment.version) {
            const map = {
              uuid: billPayment.uuid,
              version: billPayment.version
            }
            if (mapBillPayment.indexOf(map) < 0) {
              mapBillPayment.push(map)
            }
          }
        }
        batchDelBillPayment(mapBillPayment, this.location).then(res => {
          this.$refs.queryBillPayment.toQueryBillPaymentList()
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }).catch().finally()
      }).catch(() => {
      })
    },
    agreeHandler() {
      this.loading = getLoading()
      switch (this.agreeDialog.agreeType) {
        case 1:
          this.doBusinessApproval()
          break
        case 2:
          this.doDepartmentApproval()
          break
        case 3:
          this.doFinancialAudit()
          break
        case 4:
          this.doFinancialApproval()
          break
        case 5:
          this.doSupervisorAudit()
          break
      }
      this.agreeDialog.remark = ''
    },
    businessApprovalCheck() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (this.billPaymentSetting.openUiCustom) {
          if (billPayment.state === 1 && billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        } else {
          if ((this.isDepartmentPermit && billPayment.state === 6) || (!this.isDepartmentPermit && billPayment.state === 1)) {
            if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
              keys.push({ uuid: billPayment.uuid, version: billPayment.version })
            }
          }
        }
      }
      if (keys.length > 0) {
        this.agreeDialog.billPayments = keys
        this.agreeDialog.agreeType = 1
        if (this.billPaymentApproveDialogShow === 2) {
          this.agreeDialog.visible = true
        } else {
          this.doBusinessApproval()
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoBusinessApproval'))
      }
    },
    // 业务审核按钮触发事件
    doBusinessApproval() {
      const params = {
        billPayments: this.agreeDialog.billPayments,
        state: 2,
        operation: 'businessApproval',
        remark: this.agreeDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
      }).catch().finally(() => {
        this.agreeDialog.visible = false
        this.loading.close()
      })
    },
    departmentApprovalCheck() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (this.billPaymentSetting.openUiCustom) {
          const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(this.searchConditions.applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 2)
          if (billPayment.state === beforeState && billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        } else {
          if (this.isDepartmentPermit && billPayment.state === 1) {
            if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
              keys.push({ uuid: billPayment.uuid, version: billPayment.version })
            }
          }
        }
      }
      if (keys.length > 0) {
        this.agreeDialog.billPayments = keys
        this.agreeDialog.agreeType = 2
        if (this.billPaymentApproveDialogShow === 2) {
          this.agreeDialog.visible = true
        } else {
          this.doDepartmentApproval()
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDeptApproval'))
      }
    },
    // 部门审批按钮触发事件
    doDepartmentApproval() {
      const params = {
        billPayments: this.agreeDialog.billPayments,
        state: 6,
        operation: 'departmentApproval',
        remark: this.agreeDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
      }).catch().finally(() => {
        this.agreeDialog.visible = false
        this.loading.close()
      })
    },
    financialApprovalCheck() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (this.billPaymentSetting.openUiCustom) {
          const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(this.searchConditions.applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 2)
          if (billPayment.state === beforeState && billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        } else {
          if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        }
      }
      if (keys.length > 0) {
        this.agreeDialog.billPayments = keys

        this.agreeDialog.agreeType = 4
        if (this.billPaymentApproveDialogShow === 2) {
          this.agreeDialog.visible = true
        } else {
          this.doFinancialApproval()
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFinanceApprovalData'))
      }
    },
    // 财务审批按钮触发事件
    doFinancialApproval() {
      const params = {
        billPayments: this.agreeDialog.billPayments,
        state: 3,
        operation: 'financialApproval',
        remark: this.agreeDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        const keys = Array.from(this.agreeDialog.billPayments, p => p.uuid)
        this.$refs.queryBillPayment.toQueryBillPaymentList({ keys: keys, queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
      }).catch().finally(() => {
        this.agreeDialog.visible = false
        this.loading.close()
      })
    },
    backCheck() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATR'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        let map = null
        if (this.billPaymentSetting.openUiCustom) {
          this.returnDialog.returnTips = this.$t('CargoMsg.Cargo_ReturnToPreviousApprovalNode')
          map = { uuid: billPayment.uuid, version: billPayment.version, state: billPayment.state }
        } else {
          if (billPayment.state === 3) {
            map = { uuid: billPayment.uuid, version: billPayment.version, state: 2 }
            this.returnDialog.returnTips = this.$t('Payment.Cargo_ApplicantReturnToFinancialTips')
          } else if (billPayment.state === 2) {
            map = { uuid: billPayment.uuid, version: billPayment.version, state: 1 }
            this.returnDialog.returnTips = this.$t('Payment.Cargo_ApplicantReturnToBusinessTips')
          } else if (billPayment.state === 1 || billPayment.state === 6) {
            map = { uuid: billPayment.uuid, version: billPayment.version, state: 0 }
            this.returnDialog.returnTips = this.$t('Payment.Cargo_ApplicantReturnToSubmitterTips')
          }
        }
        if (map && keys.indexOf(map) < 0) {
          keys.push(map)
        }
      }
      if (keys.length > 0) {
        this.returnDialog.billPayments = keys
        if (this.billPaymentApproveDialogShow === 0 || this.billPaymentApproveDialogShow === 2) {
          this.returnDialog.visible = true
        } else {
          this.doBack()
        }
      }
    },
    // 退回按钮触发事件
    doBack() {
      this.loading = getLoading()
      const params = {
        billPayments: this.returnDialog.billPayments,
        operation: 'return',
        remark: this.returnDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).catch().finally(() => {
        this.returnDialog.visible = false
        this.returnDialog.remark = ''
        this.loading.close()
      })
    },
    financialAuditCheck() {
      if (!this.isPaymentApplyFinancialAudit) {
        this.$message.warning(this.$t('Clearing.CantDirectlyChangeConfigurationAgain'))
        return
      }
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSPATR'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
          keys.push({ uuid: billPayment.uuid, version: billPayment.version })
        }
      }
      if (keys.length > 0) {
        this.agreeDialog.billPayments = keys
        this.agreeDialog.agreeType = 3
        if (this.billPaymentApproveDialogShow === 2) {
          this.agreeDialog.visible = true
        } else {
          this.doFinancialAudit()
        }
      }
    },
    // 财务审核按钮触发事件
    doFinancialAudit() {
      const params = {
        billPayments: this.agreeDialog.billPayments,
        state: 3,
        operation: 'financialAudit',
        remark: this.agreeDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
      }).catch().finally(() => {
        this.agreeDialog.visible = false
      })
    },
    supervisorAuditCheck() {
      const chooseRows = this.$refs.queryBillPayment.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const keys = []
      for (const billPayment of chooseRows) {
        if (this.billPaymentSetting.openUiCustom) {
          const beforeState = ClearingUtils.getUiCustomBillPaymentTabState(this.searchConditions.applicationStatus, this.billPaymentSetting, this.billPaymentRuleSetting, 3)
          if (billPayment.state === beforeState && billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        } else {
          if (billPayment.uuid && keys.indexOf(billPayment.uuid) < 0 && billPayment.version) {
            keys.push({ uuid: billPayment.uuid, version: billPayment.version })
          }
        }
      }
      if (keys.length > 0) {
        this.agreeDialog.billPayments = keys
        this.agreeDialog.agreeType = 5
        if (this.billPaymentApproveDialogShow === 2) {
          this.agreeDialog.visible = true
        } else {
          this.doSupervisorAudit()
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoSupervisorApprovalData'))
      }
    },
    // 主管审核按钮触发事件
    doSupervisorAudit() {
      const params = {
        billPayments: this.agreeDialog.billPayments,
        state: 11,
        operation: 'supervisorAudit',
        remark: this.agreeDialog.remark,
        approveHistoryPlatform: true
      }
      this.jointCommonParam(params)
      updateBillPaymentState(params).then(res => {
        this.$refs.queryBillPayment.toQueryBillPaymentList({ queryMasterDb: true })
        this.$message.success(this.$t('CargoMsg.Cargo_ApprovedSuccess'))
      }).catch().finally(() => {
        this.agreeDialog.visible = false
      })
    },
    // 重新加载列表数据
    reloadData() {
      this.$refs.queryBillPayment.reQuery()
    }, // 重新加载列表数据
    cancelBillPaymentCreatorDialog() {
      // this.billPaymentCreatorDialog = null
    },
    // 保存成功回调函数
    saveBillPaymentSuccess(billPayments = []) {
      console.log('savesuccess=============')
      this.$refs.queryBillPayment.refreshRowData(billPayments)
    },
    // 列表数据发生变更
    dataProviderChange({ data, searchConditions }) {
      const applicationStatus = this.searchConditions.applicationStatus
      if (applicationStatus === 0) {
        this.searchConditions.unCommittedRowData = lodash.cloneDeep(data)
        this.searchConditions.unCommittedSearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 1) {
        this.searchConditions.unVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.unVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 2) {
        this.searchConditions.financeUnVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.financeUnVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 3) {
        this.searchConditions.verifiedRowData = lodash.cloneDeep(data)
        this.searchConditions.verifiedRowData = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 4) {
        this.searchConditions.unPaidOffRowData = lodash.cloneDeep(data)
        this.searchConditions.unPaidOffRowData = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 6) {
        this.searchConditions.departmentUnVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.departmentUnVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else if (applicationStatus === 11) {
        this.searchConditions.supervisorUnVerifyRowData = lodash.cloneDeep(data)
        this.searchConditions.supervisorUnVerifySearchConditions = lodash.cloneDeep(searchConditions)
      } else {
        this.searchConditions.allRowData = lodash.cloneDeep(data)
        this.searchConditions.allSearchConditions = lodash.cloneDeep(searchConditions)
      }
    },
    // 列表双击事件
    rowDoubleClicked(billPayment = null) {
      this.toDetail(true, billPayment)
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      console.log('toSearchTemplate', value)
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = {} // Job.queryJobLink 没有迁移过来
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    jointCommonParam(params) {
      if (!params || !this.billPaymentSetting || !this.billPaymentRuleSetting) {
        return
      }
      params.billPaymentSettingUuid = this.billPaymentSetting.uuid
      params.billPaymentRuleSettingSupervisorUuid = this.billPaymentRuleSetting.uuid
      params.branchId = this.$store.getters.currentOfficeId
      params.openUiCustom = this.billPaymentSetting.openUiCustom
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      } else {
        Object.assign(keys, this.templateSelectorDialog.data.BILL_PAYMENT_UUID_LIST)
      }
      this.loading = getLoading()
      uploadHasPrint(keys)
        .then(res => {
          if (res.ok && res.data) {
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }
        }).catch(() => { this.loading.close() }).finally(() => { this.loading.close() })
    }
  }
}
</script>

<style lang="scss">
  .changePaymentRequest {
    .el-dialog__header{
      margin-left: 8px;
    }
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__body{
      .dialog-body {
        //display: flex;
        padding: 40px 10px;
        //justify-content: left;
        //align-items: center;
        .name {
          margin-right: 20px;
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
